import React from 'react';
import '../../../styles/TopBanner.css';

const TopBanner = ({ theme = 'home', currentBanner = 0 }) => {
  return (
    <div className={`top-banner-linea ${theme}`} data-banner={currentBanner}>
      <div className="top-banner-color">
        {/* Aprovecha del <strong>10% al 40%</strong> de descuento en nuestro portafolio, consulta con tu asesor{' '} */}
        {/* <span className="fecha">Hasta el 01/08</span> */}
      </div>
    </div>
  );
};

export default TopBanner;
